import AboutFooter from "@/components/AboutFooter";
import AboutHeader from "@/components/AboutHeader";
import Footer from "@/components/Footer";
import { getGrocery } from "@/services";
import useReq from "@/utils/useReq";
import { AndroidFilled, AppleFilled } from "@ant-design/icons";
import Head from "next/head";
import { useState } from "react";
import { When } from "react-if";
import styles from "./index.module.less";

export default function AppsPage() {
  const [data, setData] = useState(null);

  useReq(async () => {
    const data = await getGrocery("about-apps");
    setData(data);
  });

  return (
    <div className={styles.page}>
      <Head>
        <title>花瓣 | 移动应用 (iPhone 、Android、iPad 客户端下载)</title>
        <meta
          name="description"
          content="花瓣网,帮你收集,发现网络上你喜欢的事物.你可以用它收集灵感,保存有用的素材,计划旅行,晒晒自己想要的东西"
        ></meta>
        <meta
          name="keywords"
          content="家居、旅行、美食、造型/妆发、摄影、服饰/搭配/街拍、童真、婚纱/婚礼、宠物、手工/布艺/玩物、建筑、创意/设计、人物、电影、音乐、图书、美女、数据"
        ></meta>
      </Head>
      <AboutHeader />
      <div className={styles.mobile}>
        <div className={styles.show}>
          <img
            src="https://grocery-cdn.huaban.com/file/577075a0b26e11f0a59ecb9f4a74cfb9.jpg"
            alt="手机展示图"
          />
        </div>
        <div className={styles.info}>
          <h1 className={styles.title}>{data?.apps?.title}</h1>
          <div className={styles.subtitle}>{data?.apps?.subtitle}</div>
          <div className={styles.card}>
            <div className={styles.qrcode}>
              <div className={styles.img}>
                <When condition={data?.apps?.qrcode[0]?.url}>
                  <img src={data?.apps?.qrcode[0]?.url} alt="手机二维码" />
                </When>
              </div>
              <div className={styles.desc}>手机扫码下载APP</div>
            </div>

            <div className={styles.action}>
              <a
                className={styles.button}
                target="_blank"
                rel="noreferrer"
                href={data?.apps?.ios?.url}
              >
                <AppleFilled className={styles.icon} />
                <div className={styles.version}>
                  <div className={styles.name}>iOS下载</div>
                  <div className={styles.num}>({data?.apps?.ios?.version})</div>
                </div>
              </a>
              <a
                className={styles.button}
                target="_blank"
                rel="noreferrer"
                href={data?.apps?.android?.files[0]?.url}
              >
                <AndroidFilled className={styles.icon} />
                <div className={styles.version}>
                  <div className={styles.name}>Android下载</div>
                  <div className={styles.num}>
                    ({data?.apps?.android?.version})
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.feature}>
        <div className={styles.item}>
          <div className={styles.title}>
            <span>发现</span>新创意
          </div>
          <div className={styles.subtitle}>每一次刷新，都能激发新的创意</div>
          <div className={styles.img}>
            <img
              src="https://grocery-cdn.huaban.com/file/576db680b26e11f0a59ecb9f4a74cfb9.jpg"
              alt="发现新创意"
            />
          </div>
        </div>
        <div className={styles.item}>
          <div className={styles.title}>
            <span>收集</span>灵感内容
          </div>
          <div className={styles.subtitle}>构建你的灵感库，随时随地查看</div>
          <div className={styles.img}>
            <img
              src="https://grocery-cdn.huaban.com/file/57730db0b26e11f0aadd17477f0bb4b9.jpg"
              alt="收集灵感内容"
            />
          </div>
        </div>
        <div className={styles.item}>
          <div className={styles.title}>
            <span>探索</span>无限灵感
          </div>
          <div className={styles.subtitle}>网罗全球灵感，海量内容任你探索</div>
          <div className={styles.img}>
            <img
              src="https://grocery-cdn.huaban.com/file/5773a9f0b26e11f0aadd17477f0bb4b9.jpg"
              alt="探索无限灵感"
            />
          </div>
        </div>
      </div>
      <AboutFooter />
      <Footer relative={true} />
    </div>
  );
}
